import React, { FC, ReactElement } from 'react';
import { Home } from '@page-components';

const HomePage: FC = (): ReactElement => {
  return <Home />;
};

export default HomePage;
